/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:none}@media (max-width:992px){[_nghost-%COMP%]{display:inline-block;font-weight:500;min-width:50%}}"];
export { styles as styles };
